var $1e6a16da88d577c6$exports = {};
/* Scroll & Nav Active Tracker */ const $1e6a16da88d577c6$var$navEl = document.querySelector("nav");
const $1e6a16da88d577c6$var$anchors = document.querySelectorAll("nav a:not([target=_blank])");
const $1e6a16da88d577c6$var$anchoredElements = [
    ...$1e6a16da88d577c6$var$anchors
].map((anchor)=>{
    const href = anchor.getAttribute("href");
    return href && href.startsWith("#") ? document.querySelector(href) : null;
}).filter(Boolean);
const $1e6a16da88d577c6$var$elementToNavAnchor = new Map($1e6a16da88d577c6$var$anchoredElements.map((element, index)=>[
        element,
        $1e6a16da88d577c6$var$anchors[index]
    ]));
let $1e6a16da88d577c6$var$oldScroll = window.scrollY;
function $1e6a16da88d577c6$var$checkVisible(elm, threshold = 150) {
    const rect = elm.getBoundingClientRect();
    const viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
    const above = rect.bottom - threshold < 0;
    const below = rect.top - viewHeight + threshold >= 0;
    return !above && !below;
}
function $1e6a16da88d577c6$var$updateNavSelection() {
    let activeSet = false;
    for (const anchoredElement of $1e6a16da88d577c6$var$anchoredElements){
        if (!anchoredElement) continue;
        const visible = $1e6a16da88d577c6$var$checkVisible(anchoredElement);
        const anchor = $1e6a16da88d577c6$var$elementToNavAnchor.get(anchoredElement);
        if (anchor) {
            anchor.classList.toggle("active", !activeSet && visible);
            if (!activeSet && visible) activeSet = true;
        }
    }
}
window.addEventListener("scroll", ()=>{
    $1e6a16da88d577c6$var$oldScroll = window.scrollY;
    $1e6a16da88d577c6$var$updateNavSelection();
}, {
    passive: true
});
/* Mobile Menu Navigation */ const $1e6a16da88d577c6$var$navButton = document.querySelector(".menu-toggle");
$1e6a16da88d577c6$var$navButton?.addEventListener("click", ()=>{
    $1e6a16da88d577c6$var$navButton.classList.toggle("open");
    $1e6a16da88d577c6$var$navEl?.classList.toggle("open");
});
$1e6a16da88d577c6$var$navEl?.addEventListener("click", (event)=>{
    if (!window.matchMedia("(max-width: 768px)").matches) return;
    if (event.target instanceof HTMLAnchorElement) {
        $1e6a16da88d577c6$var$navButton?.classList.remove("open");
        $1e6a16da88d577c6$var$navEl.classList.remove("open");
    }
});
/* Accordion Widget */ document.querySelectorAll("[data-role=expandable]").forEach((expandable)=>{
    const title = expandable.querySelector("[data-role=title]");
    const content = expandable.querySelector("[data-role=content]");
    // Ensure inner wrapper exists for CSS Grid transition
    if (content && !content.querySelector("[data-role=inner]")) {
        const inner = document.createElement("div");
        inner.setAttribute("data-role", "inner");
        while(content.firstChild)inner.appendChild(content.firstChild);
        content.appendChild(inner);
    }
    title?.setAttribute("role", "button");
    title?.setAttribute("tabindex", "0");
    const toggle = ()=>{
        const isExpanded = expandable.classList.toggle("expanded");
        title.setAttribute("aria-expanded", String(isExpanded));
    };
    title?.addEventListener("click", toggle);
    title?.addEventListener("keydown", (e)=>{
        const keyboardEvent = e;
        if (keyboardEvent.key === "Enter" || keyboardEvent.key === " ") {
            keyboardEvent.preventDefault();
            toggle();
        }
    });
});
/* Read More Widget */ document.querySelectorAll("[data-role=read_more]").forEach((expandable)=>{
    const buttonContainer = expandable.querySelector("[data-role=expand]");
    const parent = expandable.closest(".article-section");
    buttonContainer?.addEventListener("click", (event)=>{
        const target = expandable;
        const currentState = target.dataset.expandState;
        if (currentState === "open" && parent) parent.scrollIntoView({
            behavior: "smooth"
        });
        event.stopPropagation();
        event.preventDefault();
        target.dataset.expandState = currentState === "closed" ? "open" : "closed";
    });
});
/* Reference Dialog */ const $1e6a16da88d577c6$var$dialog = document.querySelector("dialog.reference_dialog");
const $1e6a16da88d577c6$var$openDialogBtn = document.querySelector("[data-role=open_dialog]");
const $1e6a16da88d577c6$var$closeDialogBtn = document.querySelector("dialog .dialog-close");
$1e6a16da88d577c6$var$openDialogBtn?.addEventListener("click", ()=>{
    $1e6a16da88d577c6$var$dialog?.showModal();
});
$1e6a16da88d577c6$var$closeDialogBtn?.addEventListener("click", ()=>{
    $1e6a16da88d577c6$var$dialog?.close();
});
$1e6a16da88d577c6$var$dialog?.addEventListener("click", (event)=>{
    if (event.target === $1e6a16da88d577c6$var$dialog) $1e6a16da88d577c6$var$dialog.close();
});


//# sourceMappingURL=index.db99f554.js.map
